module.exports = __webpack_public_path__ + "img/clock-orange.b5e7a795.svg";